import { SelectionState } from '../store';
import { storage } from '../store/storage';
import { PreviousSearch, PREVIOUS_SEARCHES_KEY } from '../common';

export const writePreviousSearchesToStore = (selection: SelectionState): void => {
  const previousSearches = storage.local.get<PreviousSearch[]>(PREVIOUS_SEARCHES_KEY) ?? [];

  const previousSearch: PreviousSearch = {
    directFlights: selection.directFlights,
    paxAmount: selection.paxAmount,
    travelClass: selection.travelClass,
    travelDates: selection.travelDates,
    travelType: selection.travelType,
    origin: {
      locationCode: selection.locations[selection.activeLocationIndex].origin.locationCode,
      cityName: selection.locations[selection.activeLocationIndex].origin.cityName,
      type: selection.locations[selection.activeLocationIndex].origin.type,
    },
    destination: {
      locationCode: selection.locations[selection.activeLocationIndex].destination.locationCode,
      cityName: selection.locations[selection.activeLocationIndex].destination.cityName,
      type: selection.locations[selection.activeLocationIndex].destination.type,
    },
    creationDate: Date.now(),
    promoCode: selection.promoCode || null,
    locale: selection.locale,
  };

  const previousIndex = previousSearches.findIndex(
    (ps) =>
      ps.origin.locationCode === selection.locations[selection.activeLocationIndex].origin.locationCode &&
      ps.destination.locationCode === selection.locations[selection.activeLocationIndex].destination.locationCode
  );

  const newSearches =
    previousIndex !== -1
      ? [previousSearch, ...previousSearches.slice(0, previousIndex), ...previousSearches.slice(previousIndex + 1)]
      : [previousSearch, ...previousSearches.slice(0, 1)];

  storage.local.set(PREVIOUS_SEARCHES_KEY, newSearches);
};
